import React, { useEffect, useState } from 'react';
import { FaEye } from "react-icons/fa";

// Get the current time rounded to the last 3-minute interval (in seconds)
function get3MinSeed() {
  const now = new Date();
  const flooredMinutes = now.getMinutes() - (now.getMinutes() % 3);
  const flooredTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getHours(),
    flooredMinutes,
    0,
    0
  );
  return Math.floor(flooredTime.getTime() / 1000);
}

// Deterministic PRNG
function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function generateRandom2Digit(seed) {
  const rng = mulberry32(seed);
  return Math.floor(rng() * 90) + 10; // Range: 10–99
}

const RandomNumber = ({ mrp }) => {

  const [randomNumber, setRandomNumber] = useState(null);

  useEffect(() => {
    if (!mrp) return;

    const updateNumber = () => {
      const timeSeed = get3MinSeed();
      const combinedSeed = timeSeed + parseInt(mrp, 10); // MRP as part of seed
      const number = generateRandom2Digit(combinedSeed);
      setRandomNumber(number);
    };

    updateNumber(); // Initial load
    const interval = setInterval(updateNumber, 60 * 1000); // Every 1 minute

    return () => clearInterval(interval);
  }, [mrp]);

  return (
    <div>
      <p><FaEye /> {randomNumber} people are currently watching this product</p>
    </div>
  );
};

export default RandomNumber;
